import React, {useState} from "react";

import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import {Visibility, VisibilityOff} from "@mui/icons-material";

function VLFTextField(props) {
	const {
		className,
		name,
		value,
		onChange,
		type = "text",
		size = "normal",
		margin = "normal",
		label,
		placeholder,
		variant,
		required = false,
		editable = true,
		onlyLabel = false,
		disabled = false,
		readOnly = false,
		helperText,
		error = false,
		fullWidth = true,
		multiline = false,
		start = undefined,
		end = undefined,
		minRows = 1,
		maxRows = 1,
		inputProps,
	} = props;

	const [showPassword, setShowPassword] = useState(false);

	let inputType = type || undefined;
	if (type === "phone") {
		inputType = "text";
	}

	const [managedInputType, setManagedInputType] = useState(inputType);

	const handleInput = (event) => {
		let value = event.target.value;

		if (type === "phone") {
			value = value.replace(/[^0-9+]/g, "");

			if (value.startsWith("+")) {
				value = "+" + value.slice(1).replace(/\+/g, "");
			} else {
				value = value.replace(/\+/g, "");
			}
		}

		event.target.value = value;
		onChange(event);
	};

	return (
		<>
			{label && (
				<div className="field-label-container">
					<div className="field-label">{label}</div>
					{required && !onlyLabel && <div className="field-required">*</div>}
				</div>
			)}
			{editable ? (
				<TextField
					className={className}
					name={name}
					value={value}
					onChange={handleInput}
					type={managedInputType}
					size={size}
					margin={margin}
					InputLabelProps={{shrink: true}}
					placeholder={placeholder || label}
					variant={variant}
					required={required}
					disabled={disabled}
					helperText={helperText}
					error={error}
					fullWidth={fullWidth}
					maxRows={multiline ? (readOnly ? undefined : maxRows) : undefined}
					inputProps={inputProps}
					sx={{
						...(readOnly &&
							multiline && {
								"& .MuiOutlinedInput-root": {
									// rimuove il bordo
									"& .MuiOutlinedInput-notchedOutline": {border: 0},
									backgroundColor: "transparent",
									padding: "0px",
								},
								// rimuove padding dell’input multiline
								"& .MuiOutlinedInput-input": {padding: 0},
								"& .MuiInputBase-inputMultiline": {
									padding: 0,
									overflow: "hidden",
									resize: "none",
									whiteSpace: "pre-wrap", // va a capo e mantiene \n
									textAlign: "justify",
								},
							}),
					}}
					InputProps={{
						readOnly,
						startAdornment: start ? (
							<InputAdornment position="start">{start}</InputAdornment>
						) : undefined,
						endAdornment: end ? (
							<InputAdornment position="end">{end}</InputAdornment>
						) : type === "password" ? (
							<InputAdornment position="end">
								<IconButton
									aria-label="toggle password visibility"
									onClick={() => {
										setShowPassword(!showPassword);
										setManagedInputType(showPassword ? "password" : "text");
									}}
									edge="end"
								>
									{showPassword ? <VisibilityOff /> : <Visibility />}
								</IconButton>
							</InputAdornment>
						) : undefined,
					}}
					multiline={multiline}
					minRows={multiline ? minRows : undefined}
				/>
			) : (
				<div className={"field-value"}>{value || "---"}</div>
			)}
		</>
	);
}

export default VLFTextField;
